function Card(props) {
    const { children } = props

    return <div
        className="block p-4 border border-expo-thin rounded-lg shadow bg-expo-medium hover:bg-expo-light cursor-pointer"
    >{children}</div>
}

export default Card
